
namespace RioERP.Masters {
    export class Rioplay8AllowedDevicesColumns {
        static columnsKey = 'Masters.Rioplay8AllowedDevices';
    }
}